import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './appRoutes';
import { Helmet } from 'react-helmet-async';
import React, { useEffect } from 'react';
import { executeScripts } from './utils';

function App({isSSR, location}: Readonly<{isSSR?: boolean, location?: string}>) {

  useEffect(() => {
    setTimeout(() => {
      executeScripts()
    }, 10000)
  }, []);

  (globalThis as any).SSR_PATHNAME = location;

  return (
    <>
    <Helmet>
        <title>Atini Studio | Custom Software Development</title>
        <meta
          name="description"
          content="A team of software developers and designers to build web/mobile app according to your vision. Whether from scratch or simply maintaining an existing application."
        />
      </Helmet>
    {isSSR ? (
    <AppRoutes />
  ) : (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )}
  </>
  )
}

export default App;
